module.exports = __webpack_public_path__ + "assets/ec01e373a7eb8219e79df34060cc42db.mp4";